import { io } from "socket.io-client"

const clientSocket = io(process.env.VUE_APP_BASE_URL, {
    auth: {
        token: localStorage.getItem("accessToken")
    },
});

export default clientSocket